<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.role_name" placeholder="请输入角色名称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="roleName" label="角色名称"></el-table-column>
            <el-table-column label="角色状态">
                <template slot-scope="scope">
                    {{ scope.row.roleStatus == 1 ? "启用" : "禁用" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.roleDate) }}
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="80px">
                    <el-form-item label="角色名称">
                        <el-input v-model="handleInfo.roleName"></el-input>
                    </el-form-item>
                    <el-form-item label="角色状态">
                        <el-select v-model="handleInfo.roleStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择权限">
                        <el-select v-model="handleInfo.rolePermissions" multiple placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in getPermissions()" :key="'permission' + item.permissionId" :label="item.permissionName" :value="item.permissionId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            permissions: []
        }
    },
    methods: {
        getPermissions: function() {
            return this.permissions.filter(item => item.permissionUrl != '#');
        },
        beforeHandleSubmit: function() {
            this.handleInfo.rolePermissions = this.handleInfo.rolePermissions.join(",");
        },
        beforeHandleOpen: function() {
            if (this.handleInfo.rolePermissions) {
                let arr = this.handleInfo.rolePermissions.split(',');
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = arr[i];
                }
                this.handleInfo.rolePermissions = arr;
                console.log(this.handleInfo.rolePermissions)
            }
        }
    },
    created: async function () {
        this.tag = "ROLE";
        this.permissions = await doGet(API.ALL.PERMISSION);
    }
}
</script>
<style scoped lang="less">
    @import "@/assets/style/list-style.less";
</style>